export default "__VITE_ASSET__1b4c6f19__"